<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Project Spectrum Event Details'"
        />
        <router-link :to="{ 
          name: 'events', 
          query: { 
            eventPage: eventPage, 
            query: query, 
            eventType: eventType, 
            eventsArchived: isEventArchived,
          }
        }">
          <v-btn
            rounded
            large
            dark
            :color="primaryButtonColor"
          >
            {{ isEventArchived == 'true' ? 'Back to Events Archives' : 'Back to Recent Events' }}
          </v-btn>
        </router-link>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Social Media Section Start -->
    <SocialMediaWidgets
      :title="title"
      :description="description"
      :type="'news'"
      :hasTopMargin="true"
    />
    <!-- Social Media Section End -->

    <!-- Event Details Start-->
    <section class="section section-blog p-0 mb-3">
      <div class="container p-0 px-3 px-lg-0 px-xl-0">
        <div class="row">
          <div class="col-12 col-lg-6 col-xl-6">
            <div class="image-container">
              <img
                :src="item?.bannerImage"
                :alt="item?.photoDescription"
                class="image-content"
              />
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xl-6">
            <div class="event-details">
              <div class="w-100 d-flex flex-row justify-content-start py-2 event-text event-header-text">
                {{ item?.eventTitle }}
              </div>
              <div v-if="isMobile" class="w-100 d-flex flex-row justify-content-start pb-2 event-text event-header-text">
                {{ `${formatDate(item?.startAt)} ${formatTime(item?.startAt)}` }}
              </div>
              <div class="w-100 py-3 d-flex flex-column justify-content-start align-items-start event-description">
                <span class="text-left" v-html="item?.description"></span>
              </div>
              <div v-if="!isMobile" class="w-100 my-2 d-flex flex-column justify-content-start">
                <div style="height: 25px;" class="w-100 text-start event-header-text">
                  DATE
                </div>
                <div style="height: 25px;" class="w-100 text-start event-header-content">
                  {{ formatDate(item?.startAt) }}
                </div>
              </div>
              <div v-if="!isMobile" class="w-100 my-2 d-flex flex-column justify-content-start">
                <div style="height: 25px;" class="w-100 text-start event-header-text">
                  TIME
                </div>
                <div style="height: 25px;" class="w-100 text-start event-header-content">
                  {{ formatTime(item?.startAt) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Event Details Section End-->
  </div>
</template>
<script>
import { BFormInput } from 'bootstrap-vue';
import axios from 'axios';
import moment from 'moment';
import { handleApiError, isLoggedIn } from '../../utils/authentication';
import SocialMediaWidgets from '../library/widgets/social-media-widgets.vue';
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import TitleTextContent from '../library/widgets/title-text-content.vue';
export default {
  name: 'events-detail',
  components: {
    BFormInput,
    SocialMediaWidgets,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  props: {
    id: String,
    eventPage: String,
    query: String,
    eventType: String,
    isEventArchived: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isRegistered: false,
      registrationStatus: {},
      waitingForRegisterResponce: false,
      item: {},
      categories: [
        { name: 'Cyber Security', articles: 4 },
        { name: 'Software', articles: 5 },
        { name: 'Manufacturing', articles: 6 },
        { name: 'Learning Tools', articles: 7 },
      ],
      archives: [
        { name: 'February 2020', articles: 4 },
        { name: 'January 2020', articles: 5 },
        { name: 'June 2020', articles: 6 },
        { name: 'May 2020', articles: 7 },
      ],
      tags: [
        { name: 'Development' },
        { name: 'Security' },
        { name: 'Infrastructure' },
        { name: 'Androids' },
        { name: 'Phishing' },
        { name: 'Coronavirus' },
      ],
      linkCopyText: 'Click to copy url link',
    };
  },
  async created() {
    if (this.id) {
      this.item = await this.getResource(this.id);
    } else {
      this.$router.push({ path: 'events' });
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    isLoggedIn() {
      return isLoggedIn();
    },
    getRedirectRoute() {
      return `/event-detail?id=${this.$router.currentRoute.query.id}`;
    },
    title() {
      return this.item?.eventTitle || 'Title';
    },
    description() {
      return this.item?.description || 'HeadLine';
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    async getResource(id) {
      /*  API call to server: GET /api/resources/blogs */
      axios
        .get(`/api/resources/events/${id}`)
        .then((response) => {
          if (response.data.Items.length > 0) {
            /** Does an item exist for the query id */
            this.item = response.data.Items[0];
            this.item.bannerImage = this.item.imageURL || require('../../assets/images/services/webinar.jpeg');
            //console.log('Event', this.item);
            if (this.item.registrationRequired && isLoggedIn()) {
              this.getRegistrationStatus(id);
            }
          } else {
            /** If no item exists with the id, redirect to list*/
            this.$router.push({ path: 'events' });
          }
        })
        .catch((error) => {
          /** On error, redirect back to list */
          console.error(error);
          this.$router.push({ path: 'events' });
        });
    },
    async getRegistrationStatus(id) {
      this.waitingForRegisterResponce = true;
      /*  API call to server: GET /api/resources/blogs */
      axios
        .get(`/api/resources/event/status?calendarId=${id}`)
        .then((response) => {
          //console.log('Registration Status', response.data);
          if (response.data.registrantKey && response.data.webinarKey) {
            this.isRegistered = true;
            this.registrationStatus = response.data;
          } else {
            this.isRegistered = false;
          }
        })
        .catch((error) => {
          /** On error, redirect back to list */
          handleApiError(error, null);
        })
        .finally(() => {
          this.waitingForRegisterResponce = false;
        });
    },
    async registerForEvent() {
      this.waitingForRegisterResponce = true;
      axios
        .post(`/api/gotowebinar/register`, {
          eventCalenderId: this.id,
          eventTitle: this.item.eventTitle,
          registrationRequired: this.item.registrationRequired,
          registrationStatus: true,
          webinarKey: this.item.webinarKey,
        })
        .then((response) => {
          //console.log('Register Response', response.data);
          this.getRegistrationStatus(this.id);
        })
        .catch((error) => {
          /** On error, redirect back to list */
          handleApiError(error, null);
        })
        .finally(() => {
          this.waitingForRegisterResponce = false;
        });
    },
    async unregisterForEvent() {
      this.waitingForRegisterResponce = true;
      axios
        .post(`/api/gotowebinar/deRegister`, {
          id: this.registrationStatus.id,
          registrantKey: this.registrationStatus.registrantKey,
          webinarKey: this.registrationStatus.webinarKey,
        })
        .then((response) => {
          //console.log('Un-Register Response', response.data);
          this.getRegistrationStatus(this.id);
        })
        .catch((error) => {
          /** On error, redirect back to list */
          handleApiError(error, null);
        })
        .finally(() => {
          this.waitingForRegisterResponce = false;
        });
    },
    datesAreOnSameDay(first, second) {
      return (
        first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate()
      );
    },
    formatterStartAndEndDate(start, end) {
      // Are they the same day
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      const timeOptions = { hour: 'numeric', minute: '2-digit' };
      var startDate = new Date(start);
      var endDate = new Date(end);
      if (this.datesAreOnSameDay(startDate, endDate)) {
        return `${startDate.toLocaleDateString(
          undefined,
          options
        )} ${startDate.toLocaleTimeString(
          undefined,
          timeOptions
        )} - ${endDate.toLocaleTimeString(undefined, timeOptions)}`;
      } else {
        return `${startDate.toLocaleDateString(
          undefined,
          options
        )} ${startDate.toLocaleTimeString(
          undefined,
          timeOptions
        )} - ${endDate.toLocaleDateString(
          undefined,
          options
        )} ${endDate.toLocaleTimeString(undefined, timeOptions)}`;
      }
    },
    formatDate(eventDate) {
      return moment(eventDate).format('MM/DD/YYYY');
    },
    formatTime(eventDate) {
      return moment(eventDate).format('hh:mm A');
    },
  },
};
</script>
<style scoped>
.inner-header-bg {
  background-image: url('~@/assets/images/headers/events.png');
  background-position: center center;
}
.centered-link {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
}
.image-content {
  width: 100%;
  height: auto;
}
.event-details {
  width: 100%;
  min-height: auto;
}
.event-description {
  min-height: 100px;
}
.event-text {
  color: #000;
  font-family: Rajdhani;
  font-style: normal;
  line-height: 20px;
}
.event-header-text {
  font-size: 20px;
  font-weight: 700;
}
.event-header-content {
  font-size: 18px;
  font-weight: 400;
}
</style>
